import { EventEmitter } from 'node:events'

export type InboxTicketEvent = {
  tenantId: string
  ticketId: string
  title: string
  status: 'AWAITING_EXPERT'
  updatedAt: string
}

const inboxEvents = new EventEmitter()
inboxEvents.setMaxListeners(100)

const NEW_TICKET_EVENT = 'new-ticket'

export function publishInboxTicket(event: InboxTicketEvent) {
  inboxEvents.emit(NEW_TICKET_EVENT, event)
}

export function subscribeToInboxTickets(
  tenantId: string,
  listener: (event: InboxTicketEvent) => void,
): () => void {
  const wrappedListener = (event: InboxTicketEvent) => {
    if (event.tenantId === tenantId) listener(event)
  }

  inboxEvents.on(NEW_TICKET_EVENT, wrappedListener)
  return () => inboxEvents.off(NEW_TICKET_EVENT, wrappedListener)
}
